





import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Header.module.css";

import logo from '../../assets/fusionsip-logo.png';
import { FaArrowRight } from "react-icons/fa6";

import Icon from "../icon/Icon";
import Button from "../button/Button";

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [active, setActive] = useState("about");

  
  const handleScroll = (id) => {
    const el = document.getElementById(id);

    if (el) {
      window.scrollTo({
        top: el.offsetTop - 80, // navbar height adjust
        behavior: "smooth"
      });
    }

    setActive(id);
    setMenuOpen(false);
  };

  return (
    <header className= {styles.supreme}>
    <div className={styles.header}>
      {/* LEFT - LOGO */}
      <div className={styles.logo}>
        <img src={logo} alt="logo" />
      </div>

      {/* CENTER - NAV LINKS */}
      <nav className={styles.nav}>
        <Link
        onClick={() => handleScroll("home")}
            className={active === "home" ? styles.active: ""}
        //  to="/"
        >Home</Link>
        <Link
        onClick={() => handleScroll("about")}
            className={active === "about" ? styles.active: ""}
        //  to="/"
        >About</Link>
        <Link 
        onClick={() => handleScroll("flavored")}
            className={active === "flavored" ? styles.active: ""}
        // to="/about"
        >Our Flavors</Link>
        <Link
        onClick={() => handleScroll("faqs")}
            className={active === "faqs" ? styles.active: ""}
        // to="/services"
        >Faqs</Link>
        {/* <Link 
        onClick={() => handleScroll("benefits")}
            className={active === "benefits" ? styles.active: ""}
        //  to="/contact"
         >Benefits</Link> */}
      </nav>

      {/* RIGHT - BUTTON */}
      <div className={styles.right}>
        <Button text="Contact Us" onClick={() => handleScroll("contactus")} />
        <Icon Icon={FaArrowRight} />
      </div>

      {/* HAMBURGER */}
      <div
        className={styles.menuIcon}
        onClick={() => setMenuOpen(true)}
      >
        ☰
      </div>

      {/* MOBILE MENU */}
      <div
        className={`${styles.mobileMenu} ${
          menuOpen ? styles.open : ""
        }`}
      >
        <div
          className={styles.close}
          onClick={() => setMenuOpen(false)}
        >
          ✕
        </div>


        <Link
  onClick={() => {
    handleScroll("home");
    setMenuOpen(false);
  }}
>
  HOME
</Link>
        <Link
  onClick={() => {
    handleScroll("about");
    setMenuOpen(false);
  }}
>
  ABOUT
</Link>

<Link
  onClick={() => {
    handleScroll("flavor");
    setMenuOpen(false);
  }}
>
  FLAVORS
</Link>

<Link
  onClick={() => {
    handleScroll("faqs");
    setMenuOpen(false);
  }}
>
  FAQS
</Link>



        <Button text="CONTACT US" 
  onClick={() => {
    handleScroll("contactus");
    setMenuOpen(false);
  }}/>
      </div>
    </div>
    </header>
  );
};

export default Header;